import React from "react";
import { Check, Image as ImageIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { KycStep } from "../components/KycStep";
import { StepFooter } from "../components/StepFooter";
import {
  DOCUMENT_TYPES,
  normalizeDocumentType,
} from "../services/documentRequirements";

// 单面证件确认页：重拍会清理当前面；继续会由 KycFlow 上传并推进正/反面流程。
export function DocumentReviewStep({
  document,
  side,
  requiresBack = true,
  documentType,
  error,
  busy,
  onRetake,
  onContinue,
}) {
  const { t } = useTranslation();
  const isBack = side === "back";
  const isPassport =
    normalizeDocumentType(documentType) === DOCUMENT_TYPES.PASSPORT;

  return (
    <KycStep
      labelledBy="kyc-document-review-title"
      className="document-review-step"
    >
      <div className="document-review-content w-full">
        <header className="document-review-header mx-auto">
          <h1
            id="kyc-document-review-title"
            className="text-center text-lg font-semibold tracking-tight text-slate-950"
          >
            {t(
              isBack
                ? "kyc.review.backTitle"
                : isPassport
                  ? "kyc.review.passportTitle"
                  : "kyc.review.frontTitle",
            )}
          </h1>
        </header>

        <div className="document-review-preview-shell mx-auto my-4 mb-5">
          <div
            className={`document-review-preview document-review-preview--compact flex aspect-[1.586/1] items-center justify-center overflow-hidden ${
              document.previewUrl
                ? "document-review-preview--filled"
                : "document-review-preview--empty"
            }`}
          >
            {document.previewUrl ? (
              <img
                src={document.previewUrl}
                alt={t("kyc.review.previewAlt")}
                className="block w-full object-contain"
              />
            ) : (
              <div className="flex size-full flex-col items-center justify-center gap-2 text-slate-400">
                <ImageIcon className="size-7" aria-hidden="true" />
                <span className="text-xs">{t("kyc.review.noDocument")}</span>
              </div>
            )}
          </div>
          {document.previewUrl && (
            <span className="document-review-status absolute -bottom-2 -right-2 z-10 flex size-8 items-center justify-center rounded-full bg-teal-600 text-white ring-4 ring-white">
              <Check className="size-4" strokeWidth={3} aria-hidden="true" />
            </span>
          )}
        </div>

        {document.isPlaceholder && (
          <p className="mx-auto mt-3 max-w-[18.5rem] rounded-lg border border-amber-100 bg-amber-50 px-3 py-2 text-xs leading-5 text-amber-900">
            {t("kyc.review.placeholderNotice")}
          </p>
        )}
        {error && (
          <p className="mx-auto mt-3 max-w-[18.5rem] text-xs text-red-700">
            {error}
          </p>
        )}

        <div className="document-review-actions mx-auto w-full">
          <StepFooter
            onBack={onRetake}
            onContinue={onContinue}
            continueLabel={
              busy
                ? t("kyc.review.uploading")
                : t(
                    isBack
                      ? "kyc.review.useBothImages"
                      : requiresBack
                        ? "kyc.review.continueToBack"
                        : "kyc.review.continue",
                  )
            }
            disabled={!document.previewUrl}
            busy={busy}
            compact
          />
        </div>
      </div>
    </KycStep>
  );
}
